import { Injectable } from '@angular/core';
import { EnvConfigurationService } from '../envconf/envconf.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../api/api.service';
import { Pagination } from '../../models/pagination';
import { DistributorDto, DistributorNoIdDto, DistributorRegionDto } from '../../models/distributor/distributor-dto';
import { PaginatedResponse, PaginatorFilters } from '@michelin/theme';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DistributorService {
  endpoint = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/distributors`;

  constructor(private readonly http: HttpClient, private readonly apiService: ApiService) {}

  getPaginatedResponse(pagination: Pagination<DistributorDto>): PaginatedResponse<DistributorDto> {
    return {
      count: pagination.totalElements,
      items: pagination.content
    };
  }

  search(paginatorFilters?: PaginatorFilters): Observable<PaginatedResponse<DistributorDto>> {
    return this.http
      .get<PaginatedResponse<DistributorDto>>(`${this.endpoint}/search${this.apiService.getQueryParams(paginatorFilters)}`)
      .pipe(map((items: Pagination<DistributorDto>) => this.getPaginatedResponse(items)));
  }

  findAll(): Observable<DistributorDto[]> {
    return this.http.get<DistributorDto[]>(`${this.endpoint}`);
  }

  findById(distributorId: number): Observable<DistributorDto> {
    return this.http.get<DistributorDto>(`${this.endpoint}/${distributorId}`);
  }

  create(data: DistributorNoIdDto): Observable<DistributorDto> {
    return this.http.post<DistributorDto>(this.endpoint, data);
  }

  update(distributorId: number, data: DistributorNoIdDto): Observable<DistributorDto> {
    return this.http.put<DistributorDto>(`${this.endpoint}/${distributorId}`, data);
  }

  exportExcel() {
    return this.http.get(`${this.endpoint}/download`, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  upload(file: File): Observable<Object> {
    const data = new FormData();
    data.append('file', file);
    return this.http.post(`${this.endpoint}/upload`, data);
  }

  findByCityIdAndProductLine(citiId: number, productLineId: number): Observable<DistributorDto> {
    return this.http.get<DistributorDto>(`${this.endpoint}/city/${citiId}/productline/${productLineId}`);
  }

  getStatesWithoutDistributor(): Observable<DistributorRegionDto[]> {
    return this.http.get<DistributorRegionDto[]>(`${this.endpoint}/statesWithoutDistributor`);
  }
}
